import { useEffect, useState } from 'react';
import { resetPasswordApi } from '../../Service/ApiService';
import { useNavigate, useLocation } from 'react-router-dom';
import { showSuccessAlert } from 'utils/SuccessMessage';
import CryptoJS from 'crypto-js';

const clearLoginSession = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('loginMenu');
  localStorage.removeItem('role');
  localStorage.removeItem('token');
  localStorage.removeItem('confvalue');
  localStorage.removeItem('DeliveryFormdata');
  localStorage.removeItem('authenticated');
  sessionStorage.removeItem('csrfToken');
  sessionStorage.removeItem('firstLoginUserCode');
};

const ResetPasswordController = (initialState, validate) => {
  const location = useLocation();
  const { resetToken, isFirstLogin, userCode } = location.state || {};
  const firstLoginUserCode = userCode || sessionStorage.getItem('firstLoginUserCode') || '';
  const isFirstLoginFlow = isFirstLogin || Boolean(firstLoginUserCode);

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!resetToken && !isFirstLoginFlow) {
      clearLoginSession();
      navigate('/login', { replace: true });
    }
  }, [resetToken, isFirstLoginFlow, navigate]);

  const handleBackToLogin = () => {
    clearLoginSession();
    window.location.replace('/login');
  };

  const handleChange = (e) => {
    let inputValue = e.target.value;

    if (e.target.name === 'new_password') {
      const newPassValue = e.target.value; // take full input
      setFormData({ ...formData, [e.target.name]: newPassValue });

      // Validate immediately
      setErrors({
        ...errors,
        [e.target.name]: newPassValue.length < 8 ? 'Password must be at least 8 characters' : ''
      });
      return;
    }


    setFormData({ ...formData, [e.target.name]: inputValue });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      if (!resetToken && !isFirstLoginFlow) {
        setApiError('Password reset session expired. Please verify OTP again.');
        return;
      }

      try {
        setLoading(true);
        const encryptedPassword = CryptoJS.MD5(formData.new_password).toString();
        const response = await resetPasswordApi(resetToken, encryptedPassword, {
          isFirstLogin: isFirstLoginFlow,
          userCode: firstLoginUserCode
        });
        if (response.success) {
          clearLoginSession();
          await showSuccessAlert(
            response.msg ? `${response.msg} Please login again.` : 'Password reset successfully. Please login again.',
            'Please Login Again'
          );
          window.location.replace('/login');
        } else {
          setApiError(response.msg);
        }
      } catch (error) {
        setApiError('Something went wrong!');
      } finally {
        setLoading(false);
      }
    }
  };

  return {
    formData,
    errors,
    apiError,
    loading,
    handleChange,
    handleResetPassword,
    handleBackToLogin
  };
};

export default ResetPasswordController;
